export function parseLocalDateTime(str) {
  if (!str || typeof str !== "string") return null;

  // ✅ normalize formats: " " → "T"
  const normalized = str.replace(" ", "T");

  const d = new Date(normalized);

  return isNaN(d.getTime()) ? null : d;
}
